import { NavLink, Outlet } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useSignOut } from '../auth/AuthProvider';

export function PortalLayout() {
  const signOut = useSignOut();

  return (
    <div className="min-h-screen bg-cime-bg">
      <header className="bg-cime-surface border-b border-neutral-200">
        <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <span
              className="text-lg font-semibold text-cime-text-primary"
              style={{ fontFamily: 'var(--cime-font-heading)' }}
            >
              CIME Avocats
            </span>
            <nav className="flex items-center gap-1">
              <NavLink
                to="/portail/dossiers"
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-md text-sm ${
                    isActive
                      ? 'bg-neutral-100 text-cime-text-primary font-medium'
                      : 'text-cime-text-muted hover:bg-neutral-50'
                  }`
                }
              >
                Mes dossiers
              </NavLink>
              <NavLink
                to="/portail/profil"
                className={({ isActive }) =>
                  `px-3 py-1.5 rounded-md text-sm ${
                    isActive
                      ? 'bg-neutral-100 text-cime-text-primary font-medium'
                      : 'text-cime-text-muted hover:bg-neutral-50'
                  }`
                }
              >
                Mon profil
              </NavLink>
            </nav>
          </div>
          <button
            type="button"
            onClick={signOut}
            className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-cime-text-muted hover:bg-neutral-50 rounded-md"
          >
            <LogOut className="w-4 h-4" />
            Déconnexion
          </button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
